import React from 'react';
import { Checkbox } from 'semantic-ui-react';
import difference from 'lodash.difference';
import intersection from 'lodash.intersection';
import { FieldInputProps } from 'react-final-form';
import { EntityId } from 'services/entities/types';

interface Props {
    innerEntityIds: number[];
    input: FieldInputProps<any, HTMLElement>;
}

export default class RenderEntityTableRowVarietyCheckbox extends React.PureComponent<Props> {
    get checked(): boolean {
        const {
            input: { value },
            innerEntityIds
        } = this.props;
        if (!innerEntityIds || !innerEntityIds.length) {
            return false;
        }

        return !difference([...value, ...innerEntityIds], value).length;
    }

    get indeterminate(): boolean {
        const {
            input: { value },
            innerEntityIds
        } = this.props;

        if (this.checked) {
            return false;
        }

        const varietyValues =
            value &&
            value.filter((entityId: EntityId) =>
                innerEntityIds.includes(entityId)
            );

        return !!intersection(varietyValues, innerEntityIds).length;
    }

    handleChange = (): void => {
        const {
            input: { value, onChange },
            innerEntityIds
        } = this.props;

        if (!this.checked && !this.indeterminate && innerEntityIds) {
            onChange([...value, ...innerEntityIds]);
        } else {
            onChange(
                value.filter(
                    (entityId: EntityId) => !innerEntityIds.includes(entityId)
                )
            );
        }
    };

    render(): React.ReactElement {
        return (
            <Checkbox
                checked={this.checked}
                indeterminate={this.indeterminate}
                onChange={this.handleChange}
            />
        );
    }
}
